<script lang="ts" setup>
import { useGlobalUser } from "@/stores/globalUser";
import { computed, ComputedRef } from "vue";
import { showConfirmDialog, showLoadingToast } from "vant";
import { useI18n } from "vue-i18n";

const user = useGlobalUser();
const { t } = useI18n();
const settingList: {
  icon: string;
  title: string;
  hide?: ComputedRef<boolean>;
  settingItems: {
    label: string;
    value: ComputedRef<boolean>;
    onChange: (value: boolean) => void | Promise<void>;
  }[];
}[] = [
  {
    icon: "ic--outline-18-up-rating",
    title: "setting.sensitiveContentPreference",
    hide: computed(() => user.isCN),
    settingItems: [
      {
        label: "User.mate.isNsfwVisible",
        value: computed(() => !!user.user.isNsfwVisible),
        onChange: async (value: boolean) => {
          try {
            await showConfirmDialog({
              title: t("ConfirmModal.reloadApp"),
              message: t("ConfirmModal.reloadAppDesc"),
              confirmButtonText: t("Buttons.confirm"),
              cancelButtonText: t("Buttons.cancel"),
            });
          } catch {
            // 取消
            return;
          }
          const loading = showLoadingToast(t("Message.saving"));
          try {
            await user.updateUserApi({ isNsfwVisible: value ? 1 : 0 });
          } finally {
            loading.close();
          }
          location.reload();
        },
      },
      {
        label: "User.mate.isNsfwBlurry",
        value: computed(() => !!user.user.isNsfwBlurry),
        onChange: async (value: boolean) => {
          try {
            await showConfirmDialog({
              title: t("ConfirmModal.reloadApp"),
              message: t("ConfirmModal.reloadAppDesc"),
              confirmButtonText: t("Buttons.confirm"),
              cancelButtonText: t("Buttons.cancel"),
            });
          } catch {
            // 取消
            return;
          }
          const loading = showLoadingToast(t("Message.saving"));
          try {
            await user.updateUserApi({ isNsfwBlurry: value ? 1 : 0 });
          } finally {
            loading.close();
          }
          location.reload();
        },
      },
    ],
  },
];
</script>
<template>
  <div class="lg:pt-[var(--top-nav-height)]">
    <ThreadsNav :show-center="false" class="lg:hidden" show-back />
    <div class="flex flex-col gap-8 text-sm">
      <div
        v-for="(section, idx) in settingList"
        v-show="!section.hide?.value"
        :key="idx"
        class="flex flex-col gap-2"
      >
        <div class="px-4 font-bold text-lg flex gap-2">
          <i :class="section.icon" class="iconify" />
          {{ $t(section.title) }}
        </div>
        <div>
          <div v-for="(item, idx) in section.settingItems" :key="idx">
            <CellItem
              :checked="item.value?.value"
              :label="$t(item.label)"
              is-checkbox
              @update:checked="item.onChange"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
